import EVCoreProvider from '@uswitch/ev-utils/lib/context/provider';
export default EVCoreProvider;